import * as DATE from 'date-fns';
import { enUS } from 'date-fns/locale';
import { constant, identity, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { convertToRelativeTime } from './convert-to-relative-time';
import { convertToTimezone } from './convert-to-timezone';
import { isTimezoneValid } from './is-timezone-valid';
export var formatDistanceStrictShort = function formatDistanceStrictShort(end, t) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$showTimeForSameD = _ref.showTimeForSameDay,
      showTimeForSameDay = _ref$showTimeForSameD === void 0 ? false : _ref$showTimeForSameD,
      _ref$timezone = _ref.timezone,
      timezone = _ref$timezone === void 0 ? undefined : _ref$timezone,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? enUS : _ref$locale;

  return function (start) {
    if (!DATE.isValid(start) || !DATE.isValid(end)) return '';
    return pipe(timezone, isTimezoneValid, O.match(constant(identity), convertToTimezone), function (dateConversion) {
      return {
        end: dateConversion(end),
        start: dateConversion(start)
      };
    }, function (_ref2) {
      var end = _ref2.end,
          start = _ref2.start;
      return pipe(DATE.differenceInCalendarDays(end, start), Math.abs, function (numOfDays) {
        return numOfDays < 1 ? O.some(showTimeForSameDay ? DATE.format(start, 'h:mm a', {
          locale: locale
        }) : convertToRelativeTime(end, t)(start)) : numOfDays < 7 ? O.some(t('{{numOfDays}}d', {
          numOfDays: numOfDays
        })) : O.none;
      }, O.alt(function () {
        return pipe(DATE.differenceInCalendarWeeks(end, start), Math.abs, function (numOfWeeks) {
          var weeksInYear = DATE.getISOWeeksInYear(start);
          return numOfWeeks < weeksInYear ? O.some(t('{{numOfWeeks}}w', {
            numOfWeeks: numOfWeeks
          })) : numOfWeeks === weeksInYear ? O.some(t('1y')) : O.none;
        });
      }), O.getOrElse(function () {
        return t('{{numOfYears}}y', {
          numOfYears: Math.abs(DATE.differenceInYears(end, start))
        });
      }));
    });
  };
};